import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../api/hooks/useAuth";
import { LoginScreen } from "../components/login-screen";

export const Login: React.FC = () => {
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleLogin = async (username: string, password: string) => {
        try {
            await login(username, password);
            navigate("/");
        } catch (err) {
            
        }
    };

    return <LoginScreen onLogin={handleLogin} />;
};
